import {
  Inject,
  Component,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ErrorMessageUtils } from '../../utils/ErrorMessageUtils';
import { Auth, sendPasswordResetEmail } from 'firebase/auth';
import { FIREBASE_AUTH } from '../../firebase.providers';
import { AlertSeverity } from '../../ui/alert.component';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PasswordResetComponent {
  email = new FormControl('', [Validators.required, Validators.email], []);
  resetPasswordForm: FormGroup = new FormGroup({
    email: this.email,
  });
  inSubmission: boolean = false;
  showAlert: boolean = false;
  severity: AlertSeverity = 'info';
  message: string = '';

  constructor(
    private router: Router,
    @Inject(FIREBASE_AUTH) private auth: Auth,
  ) {}

  async sendPassword() {
    this.inSubmission = true;
    try {
      await sendPasswordResetEmail(
        this.auth,
        this.resetPasswordForm.value.email as string,
      );
      this.inSubmission = false;
      this.showAlert = true;
      this.severity = 'success';
      this.message = 'Email verzonden!';
    } catch (error: any) {
      this.inSubmission = false;
      this.showAlert = true;
      this.severity = 'error';
      this.message =
        ErrorMessageUtils.determineFrontendMessageBasedOnError(error);
    }
  }

  navigateToLogin() {
    this.router.navigateByUrl('/login');
  }

  navigateToRegister(): void {
    this.router.navigateByUrl('/aanmelden');
  }
}
